import React from 'react';
import CertificationQuestionMgmt from '../../screens/CertificationQuestionMgmt';

const CertificationQuestionTeacherMgmt = () => {
    return <CertificationQuestionMgmt />
}

export default CertificationQuestionTeacherMgmt;